"use client";
import AnimatedCarousel from "@/components/AnimatedCarousel";
import TestimonialCard from "@/components/TestimonialCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";


export default function TestimonialSlider({ testimonials, lang, linkedinIcon, hideProjectLink = false }) {
	if (!testimonials?.length) return null;

	return (
		<div className="testimonial-slider">
			<AnimatedCarousel className="testimonial-carousel">
				<Swiper
					modules={[Navigation, Pagination]}
					navigation
					pagination={{ clickable: true }}
					centeredSlides={false}
					centeredSlidesBounds={true}
					breakpoints={{
						900: { slidesPerView: 2, spaceBetween: 30 },
						0: { slidesPerView: "auto", spaceBetween: 20 },
					}}
				>
					{testimonials.map((testimonial) => (
						<SwiperSlide key={testimonial._id}>
							<TestimonialCard testimonial={testimonial} lang={lang} hideProjectLink={hideProjectLink} />
						</SwiperSlide>
					))}
				</Swiper>
			</AnimatedCarousel>
		</div>
	);
}
